import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Popover } from 'rsuite';
import { icons } from '@shared/static/icons';
import { useTopUpBalanceDialog } from '@utils/dialogs-hooks';

const BalancesTableMobileMenu = forwardRef(({ close, ...rest }, ref) => {
  const { t } = useTranslation();
  const { openTopUpDialog } = useTopUpBalanceDialog();

  return (
    <Popover ref={ref} {...rest} full onClick={(e) => e.stopPropagation()}>
      <Dropdown.Menu onSelect={close} className="dropdown-menu">
        <Dropdown.Item onSelect={() => {}} icon={icons.export}>
          Export
        </Dropdown.Item>
        <Dropdown.Item onSelect={() => {}} icon={icons['arrow-down']}>
          Withdraw
        </Dropdown.Item>
        <Dropdown.Item onSelect={openTopUpDialog} icon={icons['arrow-up']}>
          {t('Top Up')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Popover>
  );
});
BalancesTableMobileMenu.displayName = 'BalancesTableMobileMenu';

export default BalancesTableMobileMenu;
